import { groupBy, mapValues, sortBy } from 'lodash';

import { AvailabilityState, ProductWithAttributes } from '@gn-audio/jss-core';

import { StandardPriceModel } from 'api/pricesApi/pricesModel';
import { FamilyGroup } from 'api/productCatalogueApi';
import { isNotNil } from 'utils/utils';

export const sortGroupsByAvailability = (
  groups: FamilyGroup[],
  prices: StandardPriceModel[]
): FamilyGroup[] => {
  return sortBy(
    groups,
    [
      (gr) => {
        const price = prices.find((p) => p.sku === gr.sku);
        if (!price) return AvailabilityState.ComingSoon;
        return price?.availabilityState;
      },
    ],
    ['asc']
  );
};

export const Meta3dEngravingRenderingUuidAttribute = 'Meta_3dEngravingRenderingUuid';
export const ProductPortfolioAttribute = 'Product_Portfolio';
export const MetaProducttypeAttribute = 'Meta_Producttype';
export const ProductEngravingAttribute = 'Product_Engraving';
export const ProductBrandColorAttribute = 'Product_BrandColorPublicWeb';

//TODO: Move to jss-components
export const getAvailabilityState = (
  price?: StandardPriceModel | null
): AvailabilityState | null => {
  if (price === undefined) {
    return null;
  }

  if (price === null) {
    return AvailabilityState.WhereToBuy;
  }

  const { availabilityState } = price;
  if (typeof availabilityState === 'number' && availabilityState in AvailabilityState) {
    return availabilityState as unknown as AvailabilityState;
  }

  return AvailabilityState.WhereToBuy;
};

export const getGroupAttributesObject = (
  group?: FamilyGroup | ProductWithAttributes
): Record<string, string[]> => {
  if (!group) return {};
  const attributesDictionary = groupBy(group?.attributes, (attr) => attr.key);
  return mapValues(attributesDictionary, (attributes) =>
    attributes.map((attr) => attr.valueKey).filter(isNotNil)
  );
};

export const getAttributeValue = (
  group: FamilyGroup | ProductWithAttributes | undefined,
  attributeName: string
): string | undefined => {
  if (!group) return;
  return group.attributes?.find((attr) => attr.key === attributeName)?.value ?? undefined;
};
